<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
  rel="stylesheet">
<mat-card>
    <mat-card-header>
      <mat-card-title>
        <i class="material-icons" id="User-Stats">groups</i>
        
        <strong> User-Stats</strong>
      </mat-card-title>
      
    </mat-card-header>
    <br>
    <mat-card-content>
      <div class="mat-card-content-div">
        <span class="cell-heading">Active</span>
        <br>
        <span class="cell-body txt-green ng-binding" id="stats-active-users">12846</span>
        <hr>
        <span class="cell-heading">Inactive</span>
        <br>
        <span class="cell-body txt-red ng-binding" id="stats-inactive-users">71422</span>
        <hr>
        <span class="cell-heading">Total</span>
        <br>
        <span class="cell-body txt-blue ng-binding" id="stats-total-users">84268</span>
        <br><br>
        <i class="text-muted">
            Active and Inactive users are calculated based on their past 30 days login activities.
        </i>
    </div>
    </mat-card-content>
</mat-card>
  